import ResponsiveHelper from "../utils/ResponsiveHelper";
import GsapScrollUtils from "../utils/GsapScrollUtils";

export default class PageDesign {
  constructor(dom) {
    this.dom = dom;
    window.addEventListener("resize", () => this.resize());
    this.gsu = null;
    this.init();
  }
  async init() {
    this.initResponsiveHelper();
    this.initGsap();
  }

  initResponsiveHelper() {
    this.rHelper = new ResponsiveHelper();
    window.addEventListener("onBreakpointChange", (e) => {
      //console.log(e.detail);
    });
  }

  initGsap() {
    this.gsu = new GsapScrollUtils();

    this.gsu.fadeOutOnLeave("[js-anim-fool]", {
      scrub: true,
      markers: false,
      playOnEnterBack: true,
    });

    this.gsu.fadeInOnEnter("[js-anim-fioe]", {
      scrub: true,
      markers: false,
      playOnEnterBack: true,
    });

    this.setupImgParallax();
  }

  setupImgParallax() {
    const images = this.dom.querySelectorAll("[js-img-parallax]");
    if (!images || !images.length) return;

    const magnitude = 50;

    images.forEach((img, index) => {
      this.gsu.fromToWithScroll(
        img,
        {
          y: Math.pow(-1, index) * magnitude * (index + 1),
        },
        {
          y: -Math.pow(-1, index) * magnitude * (index + 1),
          ease: "none",
          scrollTrigger: {
            trigger: img.parentNode,
            start: "top bottom",
            end: "bottom top",
            scrub: true,
            markers: false,
          },
        },
      );
    });
  }

  setGsapReplay(allow) {
    if (this.gsu && typeof this.gsu.killAll === "function") {
      this.gsu.killAll();
    }
    this.initGsap();
  }

  resize() {
    if (this.gsu) {
      this.gsu.handleResize(() => {
        if (this.threeCanvas && typeof this.threeCanvas.resize === "function") {
          this.threeCanvas.resize();
        }

        // Recreate hero parallax so it uses the updated window height
        if (typeof this.setupHeroParallax === "function") {
          this.setupHeroParallax();
        }
      });
    } else if (
      this.threeCanvas &&
      typeof this.threeCanvas.resize === "function"
    ) {
      this.threeCanvas.resize();
    }
  }
}
